"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { CreateDropPart, ReferencedNft } from "@/entities/IDrop";
import { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import { AuthContext } from "../auth/Auth";
import { cicToType } from "@/helpers/Helpers";
import Link from "next/link";
import CreateDropStormPart from "./CreateDropStormPart";
import { AnimatePresence, motion } from "framer-motion";
import UserCICAndLevel, { UserCICAndLevelSize } from "../user/utils/UserCICAndLevel";
interface CreateDropStormPartsProps {
  parts: CreateDropPart[];
  mentionedUsers: ApiDropMentionedUser[];
  referencedNfts: ReferencedNft[];
  onRemovePart: (partIndex: number) => void;
}
const CreateDropStormParts: React.FC<CreateDropStormPartsProps> = t0 => {
  const $ = _c(30);
  const {
    parts,
    mentionedUsers,
    referencedNfts,
    onRemovePart
  } = t0;
  const {
    connectedProfile
  } = React.useContext(AuthContext);
  const t1 = connectedProfile?.cic ?? 0;
  let t2;
  if ($[0] !== t1) {
    t2 = cicToType(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cicType = t2;
  let t3;
  if ($[2] !== connectedProfile) {
    t3 = <div className="tw-h-10 tw-w-10 tw-bg-iron-900 tw-relative tw-flex-shrink-0 tw-rounded-lg">{connectedProfile?.pfp ? <img src={connectedProfile.pfp} alt={connectedProfile.handle ?? "user"} className="tw-h-full tw-w-full tw-object-cover tw-rounded-lg" /> : <div className="tw-h-full tw-w-full tw-rounded-lg tw-bg-iron-900" />}</div>;
    $[2] = connectedProfile;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = connectedProfile?.level ?? 0;
  let t5;
  if ($[4] !== cicType || $[5] !== t4) {
    t5 = <UserCICAndLevel level={t4} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[4] = cicType;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `/${connectedProfile?.handle}`;
  const t7 = connectedProfile?.handle ?? "user";
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><Link href={t6} className="tw-no-underline tw-text-iron-200 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{t7}</Link></p>;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5 || $[11] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-2"><div className="tw-flex tw-items-center tw-gap-x-2">{t5}{t8}</div></div>;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== mentionedUsers || $[14] !== onRemovePart || $[15] !== parts || $[16] !== referencedNfts) {
    let t11;
    if ($[18] !== mentionedUsers || $[19] !== onRemovePart || $[20] !== referencedNfts) {
      t11 = (part, partIndex) => <motion.div key={`storm-part-${part.content}-${partIndex}`} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }}><CreateDropStormPart partIndex={partIndex} part={part} mentionedUsers={mentionedUsers} referencedNfts={referencedNfts} onRemovePart={onRemovePart} /></motion.div>;
      $[18] = mentionedUsers;
      $[19] = onRemovePart;
      $[20] = referencedNfts;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    t10 = parts.map(t11);
    $[13] = mentionedUsers;
    $[14] = onRemovePart;
    $[15] = parts;
    $[16] = referencedNfts;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <AnimatePresence mode="popLayout"><motion.div className="tw-mt-4 tw-space-y-4">{t10}</motion.div></AnimatePresence>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <div className="tw-flex tw-flex-col tw-w-full">{t9}{t11}</div>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t3) {
    t13 = <div className="tw-space-y-4 tw-pb-3"><div className="tw-bg-transparent tw-relative tw-group tw-w-full tw-flex tw-flex-col tw-py-2 tw-transition-colors tw-duration-300"><div className="tw-flex tw-gap-x-3">{t3}{t12}</div></div></div>;
    $[27] = t12;
    $[28] = t3;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export default React.memo(CreateDropStormParts);